import { IClientConfig } from '@front/interfaces/client-config.interface';
import { defaultConfig } from './default.config';

export const moetConfig: IClientConfig = {
  ...defaultConfig,
  name: 'Moet Hennessy Diageo Japan',
  logo: 'assets/images/logo-Eki-noir.svg',
  moduleAccess: {
    investment: true,
    modelTypeSwitch: true,
    examples: false,
    gapAnalysis: false,
    displayAvm: false,
    configurationAsClient: false,
    digitalFocus: false,
    effectiveness: true,
    channelPerformance: false,
    scenarios: true
  }
};
